// import React, { useEffect, useRef, useState, useCallback } from "react";
// import { assets } from "../../../assets/assets";
// import { useZone } from "../../../context/ZoneContext";
// import { useTabsFilter } from "../../../context/TabsFilterContext";

// function TypeUnit({ lang }) {
//   // const { types = [], loading } = useZone();
//   const { types = [], loading } = useZone({ lang });

//   const { typeSelection = [], onFilterChange } = useTabsFilter();
//   const [isOpen, setIsOpen] = useState(false);
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     if (typeSelection.length > 0) {
//       onFilterChange("type", []);
//     }
//   }, [types?.length]);

//   const toggleType = useCallback(
//     (typeName) => {
//       const updated = typeSelection.includes(typeName)
//         ? typeSelection.filter((t) => t !== typeName)
//         : [...typeSelection, typeName];

//       onFilterChange("type", updated);
//     },
//     [typeSelection, onFilterChange],
//   );

//   const unselectedTypes = (types || [])
//     .filter((t) => !typeSelection.includes(t.id))
//     .map((t) => t.name.split(" ").pop().toUpperCase());

//   const buttonLabel = loading
//     ? "Loading Types..."
//     : types?.length === 0
//       ? "No Types Available"
//       : unselectedTypes.length === types.length
//         ? "View All"
//         : unselectedTypes.length === 0
//           ? "None"
//           : `Model ${unselectedTypes.join(", ")}`;
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   return (
//     <div className="type col-12 text-start" ref={dropdownRef}>
//       <p className="property-type">Type</p>

//       <div className="dropdown col-12" style={{ position: "relative" }}>
//         <button
//           className="btn btn-type dropdown-toggle col-12"
//           type="button"
//           onClick={() => setIsOpen((prev) => !prev)}
//         >
//           {buttonLabel}
//           <img
//             src={assets.arrowDropdownWhite}
//             alt="Filter Icon"
//             className={`filter-icon arrow-icon ${isOpen ? "open" : ""}`}
//           />
//         </button>

//         {isOpen && (
//           <div
//             className="dropdown-menu show col-12"
//             style={{
//               padding: "4px",
//               textAlign: "center",
//               display: "block",
//               position: "absolute",
//               width: "100%",
//               zIndex: 999,
//             }}
//           >
//             {(types || []).map((type) => {
//               const isSelected = typeSelection.includes(type.id);
//               return (
//                 <p
//                   key={type.id}
//                   className="dropdown-item-type"
//                   onClick={() => toggleType(type.id)}
//                   style={{
//                     cursor: "pointer",
//                     background: isSelected ? "#fff" : type.color || "#999",
//                     color: isSelected ? "#000" : "#fff",
//                     borderRadius: "6px",
//                     marginBottom: "3px",
//                     fontWeight: "bold",
//                     transition: "all 0.2s ease-in-out",
//                   }}
//                 >
//                   {type.name}
//                 </p>
//               );
//             })}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default TypeUnit;








import React, { useEffect, useRef, useCallback } from "react";
import { assets } from "../../../assets/assets";
import { useZone } from "../../../context/ZoneContext";
import { useTabsFilter } from "../../../context/TabsFilterContext";

function TypeUnit({ lang, isOpen, toggleOpen }) { 
  const { types = [], loading } = useZone({ lang });
  const { typeSelection = [], onFilterChange } = useTabsFilter();
  const dropdownRef = useRef(null);
  useEffect(() => {
    if (typeSelection.length > 0) {
      onFilterChange("type", []);
    }
  }, [types?.length]);

  const toggleType = useCallback(
    (typeName) => {
      const updated = typeSelection.includes(typeName)
        ? typeSelection.filter((t) => t !== typeName)
        : [...typeSelection, typeName];

      onFilterChange("type", updated);
    },
    [typeSelection, onFilterChange],
  );

  const unselectedTypes = (types || [])
    .filter((t) => !typeSelection.includes(t.id))
    .map((t) => t.name.split(" ").pop().toUpperCase());

  const buttonLabel = loading
    ? "Loading Types..."
    : types?.length === 0
      ? "No Types Available"
      : unselectedTypes.length === types.length
        ? "View All"
        : unselectedTypes.length === 0
          ? "None"
          : `Model ${unselectedTypes.join(", ")}`;

  return (
    <div className="type col-12 text-start" ref={dropdownRef}>
      <p className="property-type">Type</p>

      <div className="dropdown col-12" style={{ position: "relative" }}>
        <button
          className="btn btn-type dropdown-toggle col-12"
          type="button"
          onClick={toggleOpen} // استخدام الدالة المركزية
          aria-expanded={isOpen}
        >
          {buttonLabel}
          <img
            src={assets.arrowDropdownWhite}
            alt="Filter Icon"
            className={`filter-icon arrow-icon ${isOpen ? "open" : ""}`}
          />
        </button>

        {isOpen && (
          <div
            className="dropdown-menu show col-12"
            onClick={(e) => e.stopPropagation()} // منع الانغلاق عند الضغط داخل القائمة
            style={{
              padding: "4px",
              textAlign: "center",
              display: "block",
              position: "absolute",
              width: "100%",
              zIndex: 999,
            }}
          >
            {(types || []).map((type) => {
              const isSelected = typeSelection.includes(type.id);
              return (
                <p
                  key={type.id}
                  className="dropdown-item-type"
                  onClick={() => toggleType(type.id)}
                  style={{
                    cursor: "pointer",
                    background: isSelected ? "#fff" : type.color || "#999",
                    color: isSelected ? "#000" : "#fff",
                    borderRadius: "6px",
                    marginBottom: "3px",
                    fontWeight: "bold",
                    transition: "all 0.2s ease-in-out",
                  }}
                >
                  {type.name}
                </p>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default TypeUnit;